import { render } from "./HistoryPage.vue?vue&type=template&id=73bb8656&scoped=true&ts=true"
import script from "./HistoryPage.vue?vue&type=script&lang=ts"
export * from "./HistoryPage.vue?vue&type=script&lang=ts"

import "./HistoryPage.vue?vue&type=style&index=0&id=73bb8656&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73bb8656"]])

export default __exports__